import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';

import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface DownloadFileRequestParams {
	organization_id: string;
	company_id: string;
	file_id: string;
	original_name: string;
}

const Service = Resolution886ReportService.getInstance();

export const useDownloadResolution886File = () => {
	return useMutation({
		mutationFn: async (params: DownloadFileRequestParams) => Service.downloadFile(params),
		onSuccess: (response) => {
			window.open(response.url);
			message.success(I18n.get('Document created successfully'));
		},
		onError: (err: any) => {
			message.error(I18n.get(err.response.data.message));
		}
	});
};
